import * as Yup from "yup";

export default Yup.object().shape({
  password: Yup.string().required("Please fill out this field"),
  confirmPassword: Yup.string()
    .equalTo(Yup.ref("password"), "Passwords must match")
    .required("Please fill out this field")
});
